import layoutHeaderAside from '@/layout/header-aside'

const meta = { requiresAuthA: true }

export default {
  path: '/user',
  name: 'user',
  meta,
  redirect: { name: 'user-dealerManager' },
  component: layoutHeaderAside,
  children: (pre => [
    { path: '/user/dealerManager', name: `${pre}dealerManager`, component: () => import('@pages/user/dealerManager'), meta: { meta, title: '代理商' } },
    { path: '/user/dealerManager/addDealer', name: `${pre}addDealer`, component: () => import('@pages/user/dealerManager/addDealer'), meta: { meta, title: '新增代理商' } },
    { path: '/user/dealerManager/editDealer', name: `${pre}editDealer`, component: () => import('@pages/user/dealerManager/editDealer'), meta: { meta, title: '编辑代理商' } },
    { path: '/user/dealerManager/viewDealerChild', name: `${pre}viewDealerChild`, component: () => import('@pages/user/dealerManager/viewDealerChild'), meta: { meta, title: '查看代理商' } },
    { path: '/user/doctorManager', name: `${pre}doctorManager`, component: () => import('@pages/user/doctorManager'), meta: { meta, title: '医院用户' } },
    { path: '/user/doctorManager/addDoctor', name: `${pre}addDoctor`, component: () => import('@pages/user/doctorManager/addDoctor'), meta: { meta, title: '新增医院用户' } },
    { path: '/user/doctorManager/editDoctor', name: `${pre}editDoctor`, component: () => import('@pages/user/doctorManager/editDoctor'), meta: { meta, title: '编辑医院用户' } }
  ])('user-')
}
